"use client";

import { useEffect, useRef } from "react";
import { useAccount } from "wagmi";

// Fires once when a wallet connects and records the address in Redis
// so the CRM "Total Users" count reflects real wallet holders.
export function WalletTracker() {
  const { address } = useAccount();
  const trackedRef = useRef<string | null>(null);

  useEffect(() => {
    if (!address || trackedRef.current === address) return;
    trackedRef.current = address;

    const shortAddr = `${address.slice(0, 6)}…${address.slice(-4)}`;
    fetch("/api/users", {
      method:  "POST",
      headers: { "Content-Type": "application/json" },
      body:    JSON.stringify({
        id:       address.toLowerCase(),
        name:     shortAddr,
        email:    "",
        provider: "wallet",
      }),
    }).catch(() => {});
  }, [address]);

  return null;
}
